<style>
@import '../../custom/css/ver-dica.css';
</style>

<template>
  <div id="ver-lojista" class="ver-dica">
    <div class="form-fields position-relative" v-if="representante !== null">
      <h1 class="title text-uppercase font-weight-bold">Ver Representante</h1>
      <hr class="linha-amarela" />
      <div class="row">
        <div class="col-12">
          <div class="planos p-0">
            <div class="card-plano">
              <div
                class="d-flex justify-content-center"
                v-if="
                  representante[0].plano !== null &&
                  representante[0].plano.plano_id === 1
                "
              >
                <span
                  class="plano-adm-span fs-12 font-weight-bold text-uppercase position-absolute"
                  >Selecionado</span
                >
              </div>
              <div class="card-body">
                <div class="fs-28 text-center">R$ 49,90</div>
                <div class="fs-12 text-center">Mensal + 1% da venda</div>
              </div>
              <div class="card-footer p-5px">
                <div class="w-100 c-pointer btn btn-aceitar-contrato">
                  Ver e aceitar o contrato
                </div>
              </div>
            </div>
            <div class="card-plano">
              <div
                class="d-flex justify-content-center"
                v-if="
                  representante[0].plano !== null &&
                  representante[0].plano.plano_id === 2
                "
              >
                <span
                  class="plano-adm-span fs-12 font-weight-bold text-uppercase position-absolute"
                  >Selecionado</span
                >
              </div>
              <div class="card-body">
                <div class="fs-20 text-center text-uppercase">2% da venda</div>
                <div class="fs-12 text-center p-4px">pela Plataforma</div>
              </div>
              <div class="card-footer p-5px">
                <div class="w-100 c-pointer btn btn-aceitar-contrato">
                  Ver e aceitar o contrato
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="form-group">
            <label for="id">ID</label>
            <div class="text" id="id" v-if="representante[0].id !== null">
              {{ representante[0].id }}
            </div>
            <div class="text" id="id" v-else>Sem informação!</div>
          </div>
        </div>
        <div class="col-8">
          <div class="form-group">
            <label for="cadastroRazaoSocial">Razão Social</label>
            <div
              class="text"
              id="cadastroRazaoSocial"
              v-if="representante[0].razao_social !== null"
            >
              {{ representante[0].razao_social }}
            </div>
            <div class="text" id="id" v-else>Sem informação!</div>
          </div>
        </div>
        <div class="col-6">
          <div class="form-group">
            <label for="cadastroNomeFantasia">Nome Fantasia</label>
            <div
              class="text"
              id="cadastroNomeFantasia"
              v-if="representante[0].nome_fantasia !== null"
            >
              {{ representante[0].nome_fantasia }}
            </div>
            <div class="text" id="id" v-else>Sem informação!</div>
          </div>
        </div>
        <div class="col-6">
          <div class="form-group">
            <label for="cadastroNomeResponsavel">Nome Responsável</label>
            <div
              class="text"
              id="cadastroNomeResponsavel"
              v-if="representante[0].nome_responsavel !== null"
            >
              {{ representante[0].nome_responsavel }}
            </div>
            <div class="text" id="id" v-else>Sem informação!</div>
          </div>
        </div>
        <div class="col-4">
          <div class="form-group">
            <label for="cadastroRG">RG</label>
            <div
              class="text"
              id="cadastroRG"
              v-if="representante[0].rg !== null"
            >
              {{ representante[0].rg }}
            </div>
            <div class="text" id="id" v-else>Sem informação!</div>
          </div>
        </div>
        <div class="col-4">
          <div class="form-group">
            <label for="cadastroCpf">CPF</label>
            <div
              class="text"
              id="cadastroCpf"
              v-if="representante[0].cpf !== null"
            >
              {{ representante[0].cpf }}
            </div>
            <div class="text" id="id" v-else>Sem informação!</div>
          </div>
        </div>
        <div class="col-4">
          <div class="form-group">
            <label for="cadastroCnpj">CNJP</label>
            <div
              class="text"
              id="cadastroCnpj"
              v-if="representante[0].cnpj !== null"
            >
              {{ representante[0].cnpj }}
            </div>
            <div class="text" id="id" v-else>Sem informação!</div>
          </div>
        </div>
        <div class="col-8">
          <div class="form-group">
            <label for="cadastroEndereco">Endereço</label>
            <div
              class="text"
              id="cadastroEndereco"
              v-if="representante[0].endereco !== null"
            >
              {{ representante[0].endereco }}
            </div>
            <div class="text" id="id" v-else>Sem informação!</div>
          </div>
        </div>
        <div class="col-4">
          <div class="form-group">
            <label for="cadastroNumero">Número</label>
            <div
              class="text"
              id="cadastroNumero"
              v-if="representante[0].numero !== null"
            >
              {{ representante[0].numero }}
            </div>
            <div class="text" id="id" v-else>Sem informação!</div>
          </div>
        </div>
        <div class="col-5">
          <div class="form-group">
            <label for="cadastroComplemento">Complemento</label>
            <div
              class="text"
              id="cadastroComplemento"
              v-if="representante[0].complemento !== null"
            >
              {{ representante[0].complemento }}
            </div>
            <div class="text" id="id" v-else>Sem informação!</div>
          </div>
        </div>
        <div class="col-2">
          <div class="form-group">
            <label for="cadastroCep">CEP</label>
            <div
              class="text"
              id="cadastroCep"
              v-if="representante[0].cep !== null"
            >
              {{ representante[0].cep }}
            </div>
            <div class="text" id="id" v-else>Sem informação!</div>
          </div>
        </div>
        <div class="col-5">
          <div class="form-group">
            <label for="cadastroBairro">Bairro</label>
            <div
              class="text"
              id="cadastroBairro"
              v-if="representante[0].bairro !== null"
            >
              {{ representante[0].bairro }}
            </div>
            <div class="text" id="id" v-else>Sem informação!</div>
          </div>
        </div>
        <div class="col-3">
          <div class="form-group">
            <label for="cadastroCidade">Cidade</label>
            <div
              class="text"
              id="cadastroCidade"
              v-if="representante[0].cidade !== null"
            >
              {{ representante[0].cidade.nome }}
            </div>
            <div class="text" id="id" v-else>Sem informação!</div>
          </div>
        </div>
        <div class="col-3">
          <div class="form-group">
            <label for="cadastroEstado">UF</label>
            <div
              class="text"
              id="cadastroEstado"
              v-if="representante[0].estado !== null"
            >
              {{ representante[0].estado.uf }}
            </div>
            <div class="text" id="id" v-else>Sem informação!</div>
          </div>
        </div>
        <div class="col-3">
          <div class="form-group">
            <label for="cadastroCelular">Celular / Whatsapp</label>
            <div
              class="text"
              id="cadastroCelular"
              v-if="representante[0].celular !== null"
            >
              {{ representante[0].celular }}
            </div>
            <div class="text" id="id" v-else>Sem informação!</div>
          </div>
        </div>
        <div class="col-3">
          <div class="form-group">
            <label for="cadastroTelefone">Telefone</label>
            <div
              class="text"
              id="cadastroTelefone"
              v-if="representante[0].telefone !== null"
            >
              {{ representante[0].telefone }}
            </div>
            <div class="text" id="id" v-else>Sem informação!</div>
          </div>
        </div>
      </div>
      <div class="row my-4" v-if="representante[0].financeiro !== null">
        <div class="col-12">
          <h4>Contato do Financeiro</h4>
        </div>
        <div class="col-6">
          <div class="form-group">
            <label for="cadastroNomeFinanceiro">Nome do Responsável</label>
            <div
              class="text"
              id="cadastroNomeFinanceiro"
              v-if="representante[0].financeiro.nome !== null"
            >
              {{ representante[0].financeiro.nome }}
            </div>
            <div class="text" id="id" v-else>Sem informação!</div>
          </div>
        </div>
        <div class="col-6">
          <div class="form-group">
            <label for="cadastroEmailFinanceiro">E-mail do Responsável</label>
            <div
              class="text"
              id="cadastroEmailFinanceiro"
              v-if="representante[0].financeiro.email !== null"
            >
              {{ representante[0].financeiro.email }}
            </div>
            <div class="text" id="id" v-else>Sem informação!</div>
          </div>
        </div>
        <div class="col-6">
          <div class="form-group">
            <label for="cadastroNumeroFinanceiro">Telefone / Celular</label>
            <div
              class="text"
              id="cadastroNumeroFinanceiro"
              v-if="representante[0].financeiro.celular !== null"
            >
              {{ representante[0].financeiro.celular }}
            </div>
            <div class="text" id="id" v-else>Sem informação!</div>
          </div>
        </div>
        <div class="col-6">
          <div class="form-group">
            <label for="cadastroRamalFinanceiro">Ramal</label>
            <div
              class="text"
              id="cadastroRamalFinanceiro"
              v-if="representante[0].financeiro.ramal !== null"
            >
              {{ representante[0].financeiro.ramal }}
            </div>
            <div class="text" id="id" v-else>Sem informação!</div>
          </div>
        </div>
        <div class="col-12">
          <hr />
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <div class="form-group">
            <label for="cadastroEmail">E-mail</label>
            <div
              class="text"
              id="cadastroEmail"
              v-if="representante[0].usuario !== null"
            >
              {{ representante[0].usuario }}
            </div>
            <div class="text" id="id" v-else>Sem informação!</div>
          </div>
        </div>
        <div class="col-6">
          <div class="form-group">
            <label for="cadastroSenha">Senha</label>
            <div class="text" id="cadastroSenha">******</div>
          </div>
        </div>
      </div>
      <div class="form-group">
        <div
          class="btn btn-success"
          @click="editarRepresentante(representante[0].id)"
        >
          Editar
        </div>
        <div class="btn btn-voltar-dicas" @click="voltarLista()">Voltar</div>
      </div>
    </div>
    <div class="form-fields" v-else>
      <h1 class="title text-uppercase">Esse representante não existe mais!</h1>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'ver-representante',
  props: ['id'],
  computed: {
    ...mapState({
      representante: (state) => state.representante,
      estados: (state) => state.estados,
      cidades: (state) => state.cidades,
    }),
  },
  created() {
    this.$store.dispatch('showRepresentante', this.id);
    this.$store.dispatch('loadCidades');
    this.$store.dispatch('loadEstados');
  },
  methods: {
    editarRepresentante(value) {
      this.$router.push({
        name: 'administrador-editar-representante',
        params: { id: value },
      });
    },
    voltarLista() {
      this.$router.push({
        name: 'administrador-representantes',
      });
    },
  },
};
</script>
